import { UseQueryOptions, useQuery } from 'react-query';

import { ApiVerb, apiPost } from 'src/utils/api';

import { AshbyIntegration } from './types';

export const AshbyIntegrationQueryKey = 'ashby_integration';

async function getAshbyIntegration(): Promise<AshbyIntegration> {
  const response = await apiPost(ApiVerb.GET_ASHBY_INTEGRATION, {});
  return response.data.ashby;
}

export default function useAshbyIntegration(options: UseQueryOptions<AshbyIntegration>) {
  return useQuery(AshbyIntegrationQueryKey, () => getAshbyIntegration(), options);
}
